import React, { useState } from "react";
import {
  Card,
  CardContent,
  CardActions,
  Typography,
  Button,
  CardMedia,
} from "@mui/material";
import { Animal } from "src/services/types";
import { useAnimalService } from "src/services/animalService";
import { FaHorse, FaTrash } from "react-icons/fa";
import AnimalDialog from "./AnimalDialog";

const AdminAnimalCard: React.FC<{ animal: Animal }> = ({ animal }) => {
  const { removeAnimal } = useAnimalService();
  const [openDialog, setOpenDialog] = useState(false);

  const onDelete = (id: string) => {
    removeAnimal(id);
  };

  const handleOpenDialog = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  return (
    <Card onClick={handleOpenDialog}>
      <CardContent>
        <CardMedia
          component="img"
          height="140"
          image={animal.photos?.[0] || "https://via.placeholder.com/150"}
          alt={animal.name}
        />
        <Typography variant="h5" component="div">
          {animal.name}
        </Typography>
        <Typography sx={{ mb: 1.5 }} color="text.secondary">
          {animal.specie === "cattle" && <FaHorse style={{ marginRight: 8 }} />}
          {animal.specie === "sheep" && <FaHorse style={{ marginRight: 8 }} />}
          {animal.specie === "donkey" && <FaHorse style={{ marginRight: 8 }} />}
          {animal.specie}
        </Typography>
        <Typography variant="body2">Edad: {animal.age} años</Typography>
        {animal.description && (
          <Typography variant="body2" sx={{ mt: 1 }}>
            {animal.description}
          </Typography>
        )}
      </CardContent>
      <CardActions>
        <Button
          size="small"
          color="error"
          onClick={() => onDelete(animal.id)}
          variant="contained"
          startIcon={<FaTrash size={16} />}
        >
          Delete
        </Button>
      </CardActions>
      <AnimalDialog
        open={openDialog}
        onClose={handleCloseDialog}
        animal={animal}
      />
    </Card>
  );
};

export default AdminAnimalCard;
